import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private dialogStack: any[] = [];

  constructor() {
    document.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        this.handleEsc();
      }
    });
  }

  handleEsc(): void {
    const topDialog = this.dialogStack[this.dialogStack.length - 1];
    if (topDialog && typeof topDialog.hide === 'function') {
      topDialog.hide();
    }
  }  

  registerDialog(dialog: any): void {
    this.dialogStack.push(dialog);
  }

  unregisterDialog(dialog: any): void {
    this.dialogStack = this.dialogStack.filter(d => d !== dialog);
  }

  isTopMost(dialogRef: any) {
    return this.dialogStack[this.dialogStack.length - 1] === dialogRef;
  }

  getAllRegisteredDialogs() {
    return this.dialogStack;
  }
}
